module.exports = __webpack_public_path__ + "img/bank-transfer.32d36459.svg";